export default function About() {
  return (
    <section id="about" className="bg-amber-50/30 py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Title Block */}
        <div className="text-center mb-16">
          <p className="text-emerald-700 text-sm font-bold uppercase tracking-wider mb-3">MEET YOUR ADVOCATES</p>
          <h2 className="text-5xl font-bold text-gray-900" style={{ fontFamily: 'Playfair Display, serif' }}>
            Experience You Can Trust
          </h2>
        </div>

        {/* Content Grid */}
        <div className="grid md:grid-cols-5 gap-12 items-center">
          {/* Left Column - Image */}
          <div className="md:col-span-2">
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/5d35d33720b35816affe680841e87d68.jpg"
                alt="Caleb - Independent Roofing Advocate in Apex NC with 15+ years experience"
                title="Caleb - OverUnder Roofing Founder and Advocate"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Right Column - Content */}
          <div className="md:col-span-3 space-y-8">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">20+ Years Contracting Expertise</h3>
              <p className="text-gray-700 leading-relaxed text-base mb-4">
                Hi, we're the OverUnder Roofing team. Over two decades ago, we roofed our first house. Since then, we've seen homeowners repeatedly face a real time and knowledge gap when hiring a roofer.
              </p>
              <p className="text-gray-700 leading-relaxed text-base mb-4">
                The North Carolina Department of Insurance recommends getting 2–3 written estimates from local, reputable companies, verifying licenses, insurance, and references — then comparing materials and warranties on top of that.
              </p>
              <p className="text-gray-700 leading-relaxed text-base mb-4">
                Most people simply don't have the time or expertise to do that thoroughly. Many end up overpaying or picking low bids that cut corners, due to pressure tactics and sales pitches.
              </p>
              <p className="text-gray-700 leading-relaxed text-base">
                We started OverUnder Roofing to close that gap. As an independent advocate, we work solely in your interest.
              </p>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Why Independence Matters</h3>
              <p className="text-gray-700 leading-relaxed text-base mb-4">
                Unlike referral services that earn kickbacks from contractors, we operate on a simple flat-fee model. We have zero incentive to steer you toward the highest bidder. Our only goal is to help you get quality work at a fair price.
              </p>
              <p className="text-gray-700 leading-relaxed text-base">
                You'll receive ~3 vetted bids from pre-screened, licensed contractors, plus the option to include your own trusted roofer for a fair comparison. Complete transparency, every step of the way.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}